
(() => {
  if (window.elysianInfiniteScrollActive) return;
  window.elysianInfiniteScrollActive = true;

  let observer = null;
  let controller = null;
  let activeGrid = null;
  let version = 0;

  function initialize() {
    
    const grid = document.querySelector('#product-grid');
    const pagination = document.querySelector(
      '#ElysianInfinitePagination'
    );

    if (!grid || !pagination || grid === activeGrid) return;
    if (typeof window.elysianScrollCleanup === 'function') {
  window.elysianScrollCleanup();
  window.elysianScrollCleanup = null;
}

    observer?.disconnect();
    controller?.abort();

    activeGrid = grid;
    const currentVersion = ++version;

    let currentPage = Number(pagination.dataset.currentPage);
    const totalPages = Number(pagination.dataset.totalPages);
    let nextUrl = pagination.dataset.nextUrl;
    let loading = false;
    let failed = false;

    if (!nextUrl || !totalPages || currentPage >= totalPages) {
      return;
    }

    const loader = document.createElement('div');
    loader.className = 'elysian-infinite-loader';
    loader.setAttribute('role', 'status');
    loader.style.cssText =
      'text-align:center;padding:20px;font-size:14px;';

    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';

    const gridContainer = document.querySelector(
  '#ProductGridContainer'
);

gridContainer.appendChild(loader);
gridContainer.appendChild(sentinel);

    // Only hide pagination after initialization succeeds.
    pagination.style.display = 'none';

    async function loadMore() {
      if (
        loading ||
        failed ||
        !nextUrl ||
        currentVersion !== version
      ) return;

      loading = true;
      loader.textContent = 'Loading more products...';

      controller = new AbortController();

      try {
        const response = await fetch(nextUrl, {
          signal: controller.signal,
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        const html = await response.text();

        if (currentVersion !== version) return;

        const doc = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const newGrid = doc.querySelector('#product-grid');

        if (!newGrid) {
          throw new Error('Next page product grid not found');
        }

        const items = Array.from(newGrid.children);

        if (!items.length) {
          throw new Error('No products found on next page');
        }

        const fragment = document.createDocumentFragment();

        items.forEach(item => {
          const clone = document.importNode(item, true);

          clone.classList.remove(
            'scroll-trigger',
            'animate--slide-in'
          );

          clone.removeAttribute('data-cascade');
          clone.style.removeProperty('--animation-order');

          fragment.appendChild(clone);
        });

        grid.appendChild(fragment);

        // Advance using the original pagination page count.
        currentPage++;

        if (currentPage < totalPages) {
          const url = new URL(
            nextUrl,
            window.location.origin
          );

          url.searchParams.set(
            'page',
            String(currentPage + 1)
          );

          nextUrl = url.toString();
        } else {
          nextUrl = '';
        }

        loader.textContent = '';
        requestAnimationFrame(checkScrollPosition);
        

        if (!nextUrl) {
          observer?.disconnect();
          sentinel.remove();
        }

      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Elysian Infinite Scroll:', error);
          failed = true;
          observer?.disconnect();

          loader.textContent = 'Unable to load more products. ';

          const retry = document.createElement('button');
          retry.type = 'button';
          retry.textContent = 'Try Again';
          retry.style.cssText =
            'padding:10px 20px;cursor:pointer;';

          retry.addEventListener('click', () => {
            failed = false;
            retry.remove();
            loadMore();
          });

          loader.appendChild(retry);
        }
      } finally {
        loading = false;
      }
    }

    let scrollScheduled = false;

function checkScrollPosition() {
  if (loading || !nextUrl || currentVersion !== version) return;

  const gridBottom = grid.getBoundingClientRect().bottom;
  const viewportHeight = window.innerHeight;

  if (gridBottom <= viewportHeight + 600) {
    loadMore();
  }
}

function onScroll() {
  if (scrollScheduled) return;

  scrollScheduled = true;

  requestAnimationFrame(() => {
    scrollScheduled = false;
    checkScrollPosition();
  });
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onScroll);
window.elysianScrollCleanup = () => {
  window.removeEventListener('scroll', onScroll);
  window.removeEventListener('resize', onScroll);
};

  }

  function start() {
    initialize();

    const mutationObserver = new MutationObserver(() => {
      const grid = document.querySelector('#product-grid');

      if (grid && grid !== activeGrid) {
        initialize();
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
